export default __webpack_public_path__ + "static/media/exit.f870c095.svg";